import CONSTANTS from '../CONSTANTS';

const initialState = {
  entries: [],
  page: 0,
  lastPage: 1,
  limit: 10,
  totalEntries: 0,
  analysis: {},
  loadingAnalysisList: false,
  querySearch: "",
  studyTypes: [],
  patientData: {},
  loadingPatientData: false,
}

const analysisReducer = (state = initialState, action) => {
    switch (action.type) {
        case CONSTANTS.ANALYSIS_SET_LIST: 
            return {
                ...state, 
                entries: action.entries.data ? action.entries.data : [], 
                page: action.entries.page ? Number(action.entries.page) : 0,
                lastPage: action.entries.lastPage ? Number(action.entries.lastPage) : 1,
                limit: action.entries.limit ? Number(action.entries.limit) : 10,
                totalEntries: action.entries.total ? Number(action.entries.total) : 0,
                loadingAnalysisList: false
            };
        
        case CONSTANTS.ANALYSIS_SET_STUDY_TYPES:
            return {
                ...state,
                studyTypes: action.types
            };

        case CONSTANTS.ANALYSIS_SET_LOADING_LIST:
            return {...state, loadingAnalysisList: action.val};

        case CONSTANTS.ANALYSIS_SET:
            return {...state, analysis: action.data};
        
        case CONSTANTS.ANALYSIS_SET_PAGE_INDEX: 
            return {...state, page: action.page};
        
        case CONSTANTS.ANALYSIS_LOADING_PATIENT:
            return {...state, loadingPatientData: action.value};

        case CONSTANTS.ANALYSIS_SET_PATIENT_DATA:
            return {...state, patientData: {...action.data}};

        default:
            return state;
    }
}

export default analysisReducer;